import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-8 sm:flex-row">
        <div className="text-sm text-white/60">
          © {new Date().getFullYear()} <span className="text-white">ProPlay Studios</span>. All rights reserved.
        </div>
        <div className="flex items-center gap-4 text-sm text-white/60">
          <a href="#studio" className="hover:text-white">Studio</a>
          <a href="#careers" className="hover:text-white">Careers</a>
          <a href="#contact" className="hover:text-white">Contact</a>
        </div>
      </div>
    </footer>
  );
}
